export const apiVersionPrefix: string = "/api/v2";

export const packagesApiPrefix: string = `${apiVersionPrefix}/packages`;
export const getPackageApiPath: string = `${packagesApiPrefix}/getPackage`;
